export default function lazyLoader() {
    const selector = 'img.js-custom-lazy';
    const lazyImages = document.querySelectorAll(selector);

    if (lazyImages.length === 0 && !('MutationObserver' in window)) return;

    const loadImage = (img) => {
        const src = img.getAttribute('data-src');
        const srcset = img.getAttribute('data-srcset');

        if (srcset) {
            img.setAttribute('srcset', srcset);
            img.removeAttribute('data-srcset');
        }
        if (src) {
            img.setAttribute('src', src);
            img.removeAttribute('data-src');
        }

        img.classList.remove('js-custom-lazy');
    };

    if ('IntersectionObserver' in window) {
        const options = {
            root: null,
            rootMargin: '0px 0px 400px 0px',
            threshold: 0
        };

        const imageObserver = new IntersectionObserver((entries, observerInstance) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    loadImage(img);
                    observerInstance.unobserve(img);
                }
            });
        }, options);

        lazyImages.forEach((img) => imageObserver.observe(img));

        if ('MutationObserver' in window) {
            const domObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType !== Node.ELEMENT_NODE) return;

                        if (node.matches && node.matches(selector)) {
                            imageObserver.observe(node);
                        }
                        if (node.querySelectorAll) {
                            node.querySelectorAll(selector).forEach((img) => {
                                imageObserver.observe(img);
                            });
                        }
                    });
                });
            });

            domObserver.observe(document.body, { childList: true, subtree: true });
        }

    } else {
        lazyImages.forEach((img) => loadImage(img));
    }
}
